<template>
    <div id="body">
        <div class="chat-box-cc-list row">
            <div class="user-list-icon">
                <div class="chat-box">
                    <div v-on:click="showChat = !showChat" class="chat-box-header">
                        <img class="chat-bar-img" :src="user?.profile_image || require('@/assets/images/profile.png')"
                            :alt="user.name" />
                        <div class="chat-box-toggle">
                            <i v-if="showChat" class="fa fa-angle-down"></i>
                            <i v-else class="fa fa-angle-up"></i>
                        </div>
                    </div>
                    <div v-if="showChat" class="chat-box-body">
                        <div class="chat-box-overlay"></div>
                        <div class="chat-logs">
                            <div :id="'cm-msg-' + index" class="chat-msg user" v-for="(user, index) in users"
                                :key="index">
                                <span class="msg-avatar">
                                    <img width="45" :src="user?.image || require('@/assets/images/profile.png')"
                                        alt="" />
                                </span>
                                <div class="cm-msg-text">
                                    <a :id=user.id v-on:click="updateChatUsers(user)" href="javascript:void(0)">
                                        {{ user.name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="chatUsers.length">
                <FloatingChatComponent v-for="user in chatUsers.filter(
                    (item, index, self) =>
                        index === self.findIndex((t) => t.id === item.id)
                )" :key="user.id" :receiver="$parent.user" :sender="user"></FloatingChatComponent>
            </div>

        </div>
    </div>
</template>

<script>
import FloatingChatComponent from '@/components/frontend/includes/chat/FloatingChatComponent.vue'
import { GlobalEventBus } from "@/assets/js/eventBus";
import axiosInstance from "@/assets/js/axios";
import endpoints from "@/assets/js/api";
import { useUserStore } from "@/store/store";

export default {
    name: "ChatUserListComponent",
    components: {
        FloatingChatComponent
    },
    data() {
        const userStore = useUserStore();

        return {
            user: userStore.user,
            role: userStore.user.role,
            message: "",
            users: [],
            showChat: false,
            chatUsers: [],
        }
    },
    watch: {
        messages: function () {
            this.$nextTick(function () {
                if (this.showChat) this.scroll_bottom();
            });
        },
    },
    created() {
        this.getUsersList();
    },
    mounted() {
        let self = this;
        this.listenForEvent();
        GlobalEventBus.on("updateChat", function (data) {
            self.updateChat(data);
        });
        let list = localStorage.getItem("chats");
        if (list) {
            this.chatUsers = JSON.parse(list);
        }
    },
    methods: {
        async getUsersList() {
            let self = this;

            try {
                const { data } = await axiosInstance.get(endpoints.getUserChatRoute);
                self.users = data.data;
            } catch (e) {
                console.log(e)
            }
        },
        async updateChat(user) {
            let formData = new FormData();
            let self = this;
            formData.append("receiver_id", user.id);
            await axiosInstance.post(endpoints.getUserChatUpdateRoute, formData);
            let i = self.users.findIndex((u) => u.id === parseInt(user.id));
            if (i > -1) self.users.splice(i, 1);
            else self.users.push(user);
            this.updateChatUsers(user);
            this.message = "";
        },

        scroll_bottom() {
            document.getElementById("chat-logs").scrollTop =
                document.getElementById("chat-logs").scrollHeight;
        },
        updateChatUsers(user) {
            let index = this.chatUsers.findIndex(
                (u) => u.id === parseInt(user.id)
            );
            if (index > -1) {
                this.chatUsers.splice(index, 1);
            } else {
                this.chatUsers.push(user);
            }
            localStorage.setItem("chats", JSON.stringify(this.chatUsers));
        },
        closeChat(id) {
            let index = this.chatUsers.findIndex((u) => u.id === parseInt(id));
            this.chatUsers.splice(index, 1);
            localStorage.setItem("chats", JSON.stringify(this.chatUsers));
        },
        listenForEvent() {
            // let self = this;
            // window.Echo.private("chat").listen("MessageSent", (e) => {
            //     if (!self.users.findIndex((u) => e.sender_id === u.id) > -1) {
            //         self.getUsersList();
            //     }
            //     if (
            //         e.sender.id !== self.$parent.userDetail.id &&
            //         self.chatUsers.findIndex(
            //             (u) => u.id === parseInt(e.sender.id)
            //         ) < 0
            //     ) {
            //         if (e.receiver.id === self.$parent.userDetail.id) {
            //             self.updateChatUsers(e.sender);
            //         }
            //     }
            // });
        },
    },
};
</script>

<style scoped>
html,
body {
    background: #efefef;
    height: 100%;
}

#center-text {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}

#chat-circle {
    position: fixed;
    bottom: 50px;
    right: 50px;
    background: #532d5f;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    color: white;
    padding: 28px;
    cursor: pointer;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.6),
        0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.btn#my-btn {
    background: white;
    border-radius: 45px;
    padding: 13px 40px 12px;
    color: #5865c3;
}

#chat-overlay {
    background: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: none;
}

.chat-box {
    z-index: 999;
    background: #efefef;
    position: fixed;
    right: 30px;
    bottom: 2px;
    /*width: 250px;*/
    max-width: 85vw;
    max-height: 100vh;
    /*border-radius: 5px;*/
    /*   box-shadow: 0px 5px 35px 9px #464a92; */
    /*box-shadow: 0px 5px 35px 9px #ccc;*/
    border-radius: 25px 25px 0 25px;
}

.chat-box-toggle {
    float: right;
    /*margin-right: 15px;*/
    cursor: pointer;
}

.chat-box-header {
    background: #fccd05;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    border-bottom-left-radius: 25px;
    color: #812bb2;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    margin-bottom: 0;
    padding: 10px;
    text-align: justify;
}

.chat-box-body {
    position: relative;
    height: auto;
    border: 1px solid #ccc;
    overflow: hidden;
}

.chat-box-body:after {
    content: "";
    background-image: url("data:image/svg+xml;base64,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");
    opacity: 0.1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    position: absolute;
    z-index: -1;
}

#chat-input {
    background: #f4f7f9;
    width: 100%;
    position: relative;
    height: 47px;
    padding: 10px 50px 10px 15px;
    resize: none;
    outline: none;
    border: 1px solid #ccc;
    color: #888;
    border-top: none;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    overflow: hidden;
}

.chat-input>form {
    margin-bottom: 0;
}

#chat-input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
}

#chat-input::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
}

#chat-input:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
}

#chat-input:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
}

.chat-submit {
    position: absolute;
    bottom: 3px;
    right: 10px;
    background: transparent;
    box-shadow: none;
    border: none;
    border-radius: 50%;
    color: #532d5f;
    width: 35px;
    height: 35px;
}

.chat-logs {
    padding: 10px;
    height: auto;
    overflow-y: auto;
}

.chat-logs::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
}

.chat-logs::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5;
}

.chat-logs::-webkit-scrollbar-thumb {
    background-color: #5a5eb9;
}

@media only screen and (max-width: 500px) {
    .chat-logs {
        height: 40vh;
    }
}

.chat-msg.user>.msg-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    float: left;
    /*width: 15%;*/
}

.chat-msg.self>.msg-avatar img {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    float: right;
    /*width: 15%;*/
}

.cm-msg-text {
    /*background: white;*/
    padding: 5px 10px;
    /*color: #666;*/
    max-width: 80%;
    float: left;
    margin-left: 10px;
    margin-bottom: 10px;
    border-radius: 30px;
    position: relative;
    font-size: 12px;
    font-weight: 700;
}

.chat-msg {
    clear: both;
    border-bottom: 1px solid #482962;
    height: 50px;
    width: 220px;
    padding: 4px;
    /*border-radius: 29px;*/
}

.chat-msg.self>.cm-msg-text {
    float: right;
    margin-right: 10px;
    background: #482962;
    color: white;
}

.cm-msg-button>ul>li {
    list-style: none;
    float: left;
    width: 50%;
}

.cm-msg-button {
    clear: both;
    margin-bottom: 70px;
}

.chat-box-cc-list {
    z-index: 9999;
    position: fixed;
    width: 100%;
    /*height: 470px;*/
    bottom: 0;
    right: 0;
    color: #fff;
    border-radius: 50px;
    text-align: center;
    /*box-shadow: 2px 2px 3px #999;*/
    padding: 0 5px;
    flex-direction: row-reverse;
}

.user-list-icon {
    width: 290px;
}

.chat-bar-img {
    border-radius: 50px;
    width: 25px;
}
</style>
